import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import ShareIcon from '@material-ui/icons/Share';
import FeverIconButton from 'components/common/Button/FeverIconButton';
import DialogReferralShareCard from 'components/common/Dialog/DialogReferralShareCard';
import { system900, promo500, white } from 'Mui/styles/color';
import { IS_IFRAME_MODE, IFRAME_MODE_MIN_HEIGHT } from 'config/envVariable';
import { postHeightMessage } from 'client/hooks/useHeightResizePostMessage';

function ShareButton({
    isEditor = false,
    text,
    textColor = '#FFFFFF',
    bgColor = promo500.color,
    config = {},
    onClick,
    isFetchingData = false
}) {
    const [open, setOpen] = useState(false);
    const {
        variant = 'contained',
        isFixedWindow = true,
        dialogTextColor = system900.color,
        dialogBgColor = white.color,
        enableLineLiff,
        enableDisplayShareCardButton = true,
        enableDisplayShareCardImage,
        enableDisplayShareCardReferralCode = false,
        shareCardTitle,
        shareCardDesc,
        shareCardImageUrl,
        shareCardButtonText = i18n.t('btn.get_winner'),
        shareCardButtonTextColor = white.color,
        shareCardButtonBgColor = system900.color,
        shareChannel = [],
        isLoadingReferral = false,
        referralCode,
        shareLinkUrl,
        resultImageType
    } = config;

    const handleClick = () => {
        if (isEditor) {
            return;
        } else {
            setOpen(true);
        }
        if (typeof onClick === 'function') {
            onClick();
        }
    };

    const closeDialog = () => setOpen(false);

    useEffect(() => {
        if (IS_IFRAME_MODE) {
            const PADDING_UNIT = 16;
            const dialogElement = document.getElementById('dialog');
            const promoIframeContainerElement = document.getElementById('promo-client-body');
            const dialogHeight =
                dialogElement?.children.length > 0
                    ? dialogElement?.children[0]?.clientHeight
                    : IFRAME_MODE_MIN_HEIGHT;
            const promoIframeContainerHeight = promoIframeContainerElement.clientHeight;
            if (open && !isLoadingReferral) {
                if (dialogElement && promoIframeContainerElement) {
                    if (promoIframeContainerHeight > dialogHeight + PADDING_UNIT * 2) {
                        postHeightMessage(
                            Math.max(promoIframeContainerHeight, IFRAME_MODE_MIN_HEIGHT)
                        );
                    } else {
                        postHeightMessage(dialogHeight + PADDING_UNIT * 2);
                    }
                }
            } else {
                if (promoIframeContainerElement) {
                    postHeightMessage(Math.max(promoIframeContainerHeight, IFRAME_MODE_MIN_HEIGHT));
                }
            }
        }
    }, [open, isLoadingReferral]);

    return (
        // [Feat][NFV-414] Add it for gtm selector (fv-promo-share)
        <div id="fv-promo-share">
            <FeverIconButton
                variant="contained"
                text={text}
                textColor={textColor}
                bgColor={bgColor}
                icon={ShareIcon}
                iconVariant="contained"
                iconPosition="start"
                iconSize={24}
                iconButtonStyle={css`
                    padding: 8px;
                `}
                buttonStyle={css`
                    padding: 4px;
                    padding-right: ${text && '16px'};
                `}
                disabled={isFetchingData}
                onClick={handleClick}
            />
            <DialogReferralShareCard
                variant={variant}
                open={open && !isLoadingReferral}
                isFixedWindow={isFixedWindow}
                onClose={closeDialog}
                dialogTextColor={dialogTextColor}
                dialogBgColor={dialogBgColor}
                enableLineLiff={enableLineLiff}
                referralShareCardConfig={{
                    title: shareCardTitle,
                    description: shareCardDesc,
                    imageUrl: shareCardImageUrl,
                    button: {
                        enableDisplay: enableDisplayShareCardButton,
                        label: shareCardButtonText,
                        uri: shareLinkUrl,
                        textColor: shareCardButtonTextColor,
                        bgColor: shareCardButtonBgColor
                    },
                    shareChannel: shareChannel,
                    resultImageType: resultImageType
                }}
                isShowImage={enableDisplayShareCardImage}
                isShowReferralCode={enableDisplayShareCardReferralCode}
                referralCode={referralCode}
                referralLink={shareLinkUrl}
                isFetchingData={isFetchingData}
            />
        </div>
    );
}

export default ShareButton;
